import { render, staticRenderFns } from "./MapDesa.vue?vue&type=template&id=18a16456&scoped=true"
import script from "./MapDesa.vue?vue&type=script&lang=js"
export * from "./MapDesa.vue?vue&type=script&lang=js"
import style0 from "./MapDesa.vue?vue&type=style&index=0&id=18a16456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a16456",
  null
  
)

export default component.exports